import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const TrashIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faTrash} color="#C3C7CB" />;
};
